import styled from 'styled-components'
export const StyledContainer = styled.div`
  width: 90%;
  max-width:1000px;
  margin:auto;
`;
